import { render } from "./WriteInPrivate.vue?vue&type=template&id=27290532"
import script from "./WriteInPrivate.vue?vue&type=script&lang=js"
export * from "./WriteInPrivate.vue?vue&type=script&lang=js"

import "./WriteInPrivate.vue?vue&type=style&index=0&id=27290532&lang=scss"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__